import { render, staticRenderFns } from "./PsinAddEditProd.vue?vue&type=template&id=f5279d4a&scoped=true&"
import script from "./PsinAddEditProd.vue?vue&type=script&lang=js&"
export * from "./PsinAddEditProd.vue?vue&type=script&lang=js&"
import style0 from "./PsinAddEditProd.vue?vue&type=style&index=0&id=f5279d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5279d4a",
  null
  
)

export default component.exports